<template>
  <div>
    <el-dialog title="权限管理" :visible.sync="dialogVisible" :before-close="handleClose" width="500px" class="add-edit-form" v-dialogDrag>
     <div class="authority-box">
       <authority :authorityTree="authorityTree" @checkedArr="checkedArr"></authority>
     </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import authority from './tree';

export default {
  name: 'edit',
  components: {
    authority
  },
  props: {
    authorityTree: {
      type: Array
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    checkedArr(params) {
      this.data.functionIds = params.functionIds.join(',');
      this.data.resourceIds = params.resourceIds.join(',');
    },
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.dataForm.name = this.data.name;
          this.dataForm.functionIds = this.data.functionIds;
          this.dataForm.resourceIds = this.data.resourceIds;
          this.dataForm.id = this.data.id;
          this.saveRole();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async saveRole() {
      const res = await this.$services.postJson({
        type: 'ROLEMANGEMENT',
        url: 'saveRole',
        params: JSON.parse(JSON.stringify(this.dataForm))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="scss" >
@import '@/assets/css/addEditForm.scss';
</style>
